export default {
  // 登录接口
  Login: "api/v1/AppUsers/login",
  AdminLogin: "api/v1/AppUsers/loginByAdmin",
  logOut: "api/v1/AppUsers/logout",

  appUsers: {
    sendSmsNotAuth: 'api/v1/AppUsers/sendSmsNotAuth',
    loginSendSms:"api/v1/AppUsers/loginSendSms",
    register: "api/v1/AppUsers/register",
    batchRegister:"api/v1/AppUsers/batchRegister",
    getAppUsers:"api/v1/AppUsers",
    resetpassword:"api/v1/AppUsers/resetpassword",
    params:"api/v1/AppUsers/params",
    sendSmsModifyMobile:"api/v1/Users/sendSmsModifyMobile",
    modifyPassWord:"api/v1/Users/modifyPassWord", 
    forgetPwd: "api/v1/AppUsers/forgetPwd",
    forgetPwdVerify:"api/v1/AppUsers/forgetPwdVerify",
    forgetPwdSms:"api/v1/AppUsers/forgetPwdSms",
    modifyMobile:"api/v1/AppUsers/modifyMobile",
  },
  cockpit:{
    getWeather:'api/v1/Cockpit/getWeather',
    getMap:'api/v1/Cockpit/getMap',
    getCount:'api/v1/Cockpit/getCount',
    getExamResult:'api/v1/Cockpit/getExamResult',
    getWarnings:'api/v1/Cockpit/getWarnings',
    getStatistics:"api/v1/Cockpit/getStatistics"
  },

  map:{
    getParams: "api/v1/Map/getParams",
    getManageCategoryMapData:"api/v1/Map/getManageCategoryMapData", 
    getDangerWasterTypeMapData:"api/v1/Map/getDangerWasterTypeMapData"
  },
  exam:{
    getParams: "api/v1/exam/getParams",
    getList:"api/v1/exam/getList",  
  },
  companies: {
    getUserCompany: "api/v1/Companies/GetUserCompany",
    modifyCompany: "api/v1/Companies/modifyCompany",
    getCompanies: 'api/v1/Companies/getCompanies',
    getEmphasisCompanies: 'api/v1/Companies/getEmphasisCompanies',
    getGreenCompanies: 'api/v1/Companies/getGreenCompanies',
    getParams: 'api/v1/Companies/getParams',
    getCompaniesSelect: 'api/v1/Companies/getCompaniesSelect',

    downloadCompanies:"api/v1/Companies/Companies/download",
    downloadEmphasisCompanies:"api/v1/Companies/EmphasisCompanies/download",
    downloadGreenCompanies:"api/v1/Companies/GreenCompanies/download",
  },
  dangerWasters: {
    addDangerWasterList: "api/v1/DangerWasters/addDangerWasterList",
    getTypes: "api/v1/DangerWasters/getTypes",
    getCodes: "api/v1/DangerWasters/getCodes",
    getDangerWasters: "api/v1/DangerWasters/getDangerWasters",
    delete: "api/v1/DangerWasters/delete",
    add: "api/v1/DangerWasters/addDangerWaster",
    import: "api/v1/DangerWasters/importWfManagePlan",
  },
  dangerWasterDatas: {
    getDangerWasterDatas: "api/v1/DangerWasterDatas/getDangerWasterDatas",
    getHandleDangerWasterDatas: "api/v1/DangerWasterDatas/getHandleDangerWasterDatas",
    modifyRow: "api/v1/DangerWasterDatas/modifyRow",
    modifyHandleRow: "api/v1/DangerWasterDatas/modifyHandleRow",
    getCompanyYearDangerData: "api/v1/DangerWasterDatas/getCompanyYearDangerData",
    getYearOnYearDangerData: "api/v1/DangerWasterDatas/getYearOnYearDangerData",
    downloadCompanyYearDangerData: "api/v1/DangerWasterDatas/companyYearDangerData/download",
    downloadDangerWasterDatas: "api/v1/DangerWasterDatas/dangerWasterDatas/download",
    importHandleDangerWasterDatas:"api/v1/DangerWasterDatas/importHandleDangerWasterDatas"
  },
  handleContractFiles: {
    getList: "api/v1/HandleContractFile/getList",
    upload: "api/v1/HandleContractFile/upload",
    download: "api/v1/HandleContractFile/files",
    delete: "api/v1/HandleContractFile/delete",
  },
  transProvinceFiles: {
    getList: "api/v1/TransProvinceFile/getList",
    upload: "api/v1/TransProvinceFile/upload",
    download: "api/v1/TransProvinceFile/files",
    delete: "api/v1/TransProvinceFile/delete",
  },
  dangerWasterLicenseFiles: {
    getList: "api/v1/DangerWasterLicenseFile/getList",
    upload: "api/v1/DangerWasterLicenseFile/upload",
    download: "api/v1/DangerWasterLicenseFile/files",
    delete: "api/v1/DangerWasterLicenseFile/delete",
  },
  protocolCompanyZiZhiFiles: {
    getList: "api/v1/ProtocolCompanyZiZhiFile/getList",
    upload: "api/v1/ProtocolCompanyZiZhiFile/upload",
    download: "api/v1/ProtocolCompanyZiZhiFile/files",
    delete: "api/v1/ProtocolCompanyZiZhiFile/delete",
  },
  protocolCompanyContractFiles: {
    getList: "api/v1/ProtocolCompanyContractFile/getList",
    upload: "api/v1/ProtocolCompanyContractFile/upload",
    download: "api/v1/ProtocolCompanyContractFile/files",
    delete: "api/v1/ProtocolCompanyContractFile/delete",
  },
  warnings: {
    companyWarnings: "api/v1/Warnings/Company/getWarnings",
    getParams: "api/v1/Warnings/getParams",
    warnings: "api/v1/Warnings",
    dealWithWarning: "api/v1/Warnings/Company/dealWithWarning",
    getWarningStatistics: "api/v1/Warnings/getWarningStatistics",
    getAllWarnings: "api/v1/Warnings/getAllWarnings",
    urgeWarning: "api/v1/Warnings/urgeWarning",
  },
  //业务统计
  statistics: {
    getBusinessView: "api/v1/BusinessStatistics/getBusinessView",
    getManageCategoryView: "api/v1/BusinessStatistics/getManageCategoryView",
    getManageCategoryList: "api/v1/BusinessStatistics/getManageCategoryList",
    downloadManageCategoryList: "api/v1/BusinessStatistics/manageCategoryList/download", 
    getDangerDataView: "api/v1/BusinessStatistics/getDangerDataView",
    getDangerDataList: "api/v1/BusinessStatistics/getDangerDataList", 
    downloadDangerDataList: "api/v1/BusinessStatistics/dangerDataList/download", 
    getDangerTypeParams: "api/v1/BusinessStatistics/getDangerTypeParams",
    getDangerTypeOutPut: "api/v1/BusinessStatistics/getDangerTypeOutPut",
    getDangerTypeDisPos: "api/v1/BusinessStatistics/getDangerTypeDisPos",
    getDangerTypeStorage: "api/v1/BusinessStatistics/getDangerTypeStorage",
    getDangerTypeList: "api/v1/BusinessStatistics/getDangerTypeList",
    downloadDangerTypeList: "api/v1/BusinessStatistics/dangerTypeList/download",
 
    getCompanyDangerView: "api/v1/BusinessStatistics/getCompanyDangerView",
    getCompanyDangerList: "api/v1/BusinessStatistics/getCompanyDangerList",
    downloadCompanyDangerList:"api/v1/BusinessStatistics/companyDangerList/download",
    getGreenView: "api/v1/BusinessStatistics/getGreenView",
    getCompanyGreenView: "api/v1/BusinessStatistics/getCompanyGreenView",
    getGreenList: "api/v1/BusinessStatistics/getGreenList",  
    downloadGreenList:"api/v1/BusinessStatistics/greenList/download",
 
  },
  envManualFiles: {
    getList: "api/v1/EnvManualFile/getList",
    upload: "api/v1/EnvManualFile/upload",
    modify: "api/v1/EnvManualFile/modify",
    download: "api/v1/EnvManualFile/files",
    delete:"api/v1/EnvManualFile/delete",
    batchDelete:"api/v1/EnvManualFile/batchDelete", 
  },
  moreServicesV2: {
    getParams: "api/v1/MoreServices/getParams", 
    getList: "api/v1/MoreServices/getList",
    upload: "api/v1/MoreServices/upload",
    modify: "api/v1/MoreServices/modify",
    download: "api/v1/MoreServices/files",
    delete:"api/v1/MoreServices/delete",
    batchDelete:"api/v1/MoreServices/batchDelete", 
  },
  moreServices: {
    getList: "api/v1/MoreServices/getList",
    getParams: "api/v1/MoreServices/getParams", 
    modify: "api/v1/MoreServices/modify",
    getDetail:"api/v1/MoreServices/getDetail"
  },
  transportCompanies: {
    getList: "api/v1/TransportCompanies/getCompanies",
    add: "api/v1/TransportCompanies/addCompany"
  },

  // 系统管理
  system: {
    Companies: 'api/v1/Companies', //企业接口
    registerCompanies: 'api/v1/Companies/register', //企业副本注册
    documents: 'api/v1/Companies/documents',//下载副本
    AutoChecks: 'api/v1/AutoChecks',//查看副本记录
    resultAutoChecks: 'api/v1/AutoChecks/result',//查看副本结果
    downloadAutoChecks: 'api/v1/AutoChecks/result/download',//查看副本结果
    // 
    Table1s: 'api/v1/Table1s/items',//获取表单1中所有动态检查项
    Table1sList: 'api/v1/Table1s',//获取表单1中所有
    Table1sParams: 'api/v1/Table1s/params',//获取表单1参数
    Table_44sList: 'api/v1/Table_44s',//获取表单4-4中所有动态检查项
    pics: 'api/v1/Table_44s/pics',//获取表单4-4中所有动态检查项
    sign: 'api/v1/Table_44s/sign',//获取表单4-4中所有动态检查项
    samplesign: 'api/v1/Table_44s/samplesign',//获取表单4-4中所有动态检查项
  },
  // params: {
  //   Industries: "api/v1/Industries", //所属行业级联接口
  //   paramsCompanies: "api/v1/Companies/params", //污染源类型下拉接口
  //   paramsShucais: "api/v1/Shucais/params", //数采仪设备下拉接口
  //   paramsUsers: 'api/v1/Users/params', //用户管理下拉接口
  //   paramsDatas: 'api/v1/Datas/params', //历史数据下拉接口
  //   paramsReports: 'api/v1/Reports/params', //报表数据下拉接口
  // },
  // 益慧眼接口
  // params:{
  //   AppUsers:"api/v1/AppUsers"
  // },
  // MeetingRooms:{
  //   MeetingRoomsList:"api/v1/MeetingRooms",
  //   // MeetingRoomsList:'api/v1/EyeDevices'
  // },
  // EyeDevices:{
  //   EyeDevicesList:'api/v1/EyeDevices',
  //   verifymn:'api/v1/EyeDevices/verifymn',
  //   realdatas:'api/v1/EyeDevices/realdatas',
  //   Events:'api/v1/Events',
  //   video:'api/v1/Events/video'
  // },
  // Agoras:{
  //   tokenAgoras:'api/v1/Agoras/token',
  //   channels:'api/v1/Agoras/channels',
  //   users:'api/v1/Agoras/users'
  // }
};